import React, { useState } from 'react';
import { ImageList, ImageListItem, Dialog, DialogTitle, DialogContent, Typography, IconButton, Drawer } from '@mui/material';
import Slide from '@mui/material/Slide';
import ImageListItemBar from '@mui/material/ImageListItemBar';
import InfoIcon from '@mui/icons-material/Info';
import CloseIcon from '@mui/icons-material/Close';
import imageData from '../db/BooksList';
import { useTheme, useMediaQuery } from '@mui/material';


const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function Books() {
    const [open, setOpen] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);

    const theme = useTheme();
    const isXs = useMediaQuery(theme.breakpoints.down('sm'));
    const isSm = useMediaQuery(theme.breakpoints.between('sm', 'md'));
    const isMdUp = useMediaQuery(theme.breakpoints.up('md'));

    let columns = 2;
    if (isSm) columns = 3;
    if (isMdUp) columns = 5;

    const handleClick = (item) => {
        if (item.description) {
            setSelectedItem(item);
            setOpen(true);
        }
    };

    const handleClose = () => {
        setOpen(false);
        setSelectedItem(null);
    };

    return (
        <>
            <ImageList cols={columns} gap={12} sx={{ padding: 2 }}>
                {imageData.map((item) => (
                    <ImageListItem
                        key={item.id}
                        onClick={() => handleClick(item)}
                        sx={{
                            cursor: item.description ? 'pointer' : 'default',
                            position: 'relative',
                            border: item.description ? '1px solid rgba(255, 132, 0, 0.19)' : '2px solid transparent',
                            borderRadius: 0,
                            padding: 1,
                            overflow: 'hidden',
                            '&:hover .info-icon': {
                                opacity: item.description ? 1 : 0,
                            },
                        }}
                    >
                        <img src={item.imageUrl} alt={item.title} loading="lazy" />
                        {item.description && (
                            <InfoIcon
                                className="info-icon"
                                sx={{
                                    position: 'absolute',
                                    bottom: 8,
                                    right: 8,
                                    color: '#ffc107',
                                    backgroundColor: 'rgba(0, 0, 0, 0.6)',
                                    borderRadius: '50%',
                                    padding: '4px',
                                    fontSize: 24,
                                    opacity: 0.9,
                                    transition: 'opacity 0.3s',
                                }}
                            />
                        )}
                        <ImageListItemBar
                            sx={{ color: 'white' }}
                            title={item.title}
                            subtitle={<span>{item.author}</span>}
                            position="below"
                        />
                    </ImageListItem>
                ))}
            </ImageList>

            <Dialog
                open={open}
                onClose={handleClose}
                fullWidth
                slots={{
                    transition: Transition,
                }}
                PaperProps={{
                    sx: {
                        backgroundColor: '#111111', // Sfondo della dialog
                        color: 'white',           // Colore del testo di default
                    },
                }}

            >
                {selectedItem && (
                    <>
                        <DialogTitle>
                            {selectedItem.title}
                            <IconButton
                                aria-label="close"
                                onClick={handleClose}
                                sx={{
                                    position: 'absolute',
                                    right: 8,
                                    top: 8,
                                    color: (theme) => theme.palette.grey[500],
                                }}
                            >
                                <CloseIcon />
                            </IconButton>
                        </DialogTitle>
                        <DialogContent>
                            <Typography>{selectedItem.description}</Typography>
                        </DialogContent>
                    </>
                )}
            </Dialog>
        </>

    );
}